import React, { useState, useRef } from 'react';
import { Box, IconButton, useBreakpointValue, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaVolumeMute, FaVolumeUp, FaExpand, FaTachometerAlt } from 'react-icons/fa';

const Banner = ({ videoSrc, borderRadius }) => {
  const [isMuted, setIsMuted] = useState(true);
  const [playbackRate, setPlaybackRate] = useState(1);
  const videoRef = useRef(null);
  const isMobile = useBreakpointValue({ base: true, md: false });

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setIsMuted(!isMuted);
    }
  };

  const changePlaybackRate = (rate) => {
    if (videoRef.current) {
      videoRef.current.playbackRate = rate;
      setPlaybackRate(rate);
    }
  };

  const toggleFullscreen = () => {
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.webkitRequestFullscreen) {
        videoRef.current.webkitRequestFullscreen();
      } else if (videoRef.current.mozRequestFullScreen) {
        videoRef.current.mozRequestFullScreen();
      } else if (videoRef.current.msRequestFullscreen) {
        videoRef.current.msRequestFullscreen();
      }
    }
  };

  return (
    <Box 
      position="relative" 
      w="100%" 
      maxW="100%" 
      h={isMobile ? "50vh" : "80vh"} 
      overflow="hidden"
    >
      <motion.video 
        ref={videoRef}
        autoPlay 
        loop 
        muted={true}
        playsInline 
        controls={isMobile}
        style={{ 
          width: '100%', 
          height: '100%', 
          objectFit: isMobile ? 'contain' : 'cover', 
          borderRadius: borderRadius 
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </motion.video>

      {!isMobile && (
        <Box
          position="absolute"
          bottom="10px"
          right="10px"
          display="flex"
          gap="10px"
          alignItems="center"
          zIndex={2}
        >
          {/* Speed Control */}
          <Menu>
            <MenuButton
              as={IconButton}
              icon={<FaTachometerAlt />}
              aria-label="Playback Speed"
              colorScheme="blackAlpha"
              bg="rgba(0,0,0,0.6)"
              color="white"
              size="lg"
              _hover={{ bg: "rgba(0,0,0,0.8)" }}
            />
            <MenuList bg="rgba(0,0,0,0.9)" borderColor="rgba(255,255,255,0.2)">
              <MenuItem 
                bg="transparent" 
                color="white" 
                _hover={{ bg: "rgba(255,255,255,0.1)" }}
                onClick={() => changePlaybackRate(0.5)}
              >
                0.5x
              </MenuItem>
              <MenuItem 
                bg="transparent" 
                color="white" 
                _hover={{ bg: "rgba(255,255,255,0.1)" }}
                onClick={() => changePlaybackRate(1)}
              >
                1x
              </MenuItem>
              <MenuItem 
                bg="transparent" 
                color="white" 
                _hover={{ bg: "rgba(255,255,255,0.1)" }}
                onClick={() => changePlaybackRate(1.25)}
              >
                1.25x
              </MenuItem>
              <MenuItem 
                bg="transparent" 
                color="white" 
                _hover={{ bg: "rgba(255,255,255,0.1)" }}
                onClick={() => changePlaybackRate(1.5)}
              >
                1.5x
              </MenuItem>
              <MenuItem 
                bg="transparent" 
                color="white" 
                _hover={{ bg: "rgba(255,255,255,0.1)" }}
                onClick={() => changePlaybackRate(2)}
              >
                2x
              </MenuItem>
            </MenuList>
          </Menu>

          {/* Sound Control */}
          <IconButton
            icon={isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
            aria-label={isMuted ? "Unmute video" : "Mute video"}
            colorScheme="blackAlpha"
            bg="rgba(0,0,0,0.6)"
            color="white"
            size="lg"
            onClick={toggleMute}
            _hover={{ bg: "rgba(0,0,0,0.8)" }}
          />
          
          {/* Fullscreen Control */}
          <IconButton
            icon={<FaExpand />}
            aria-label="Fullscreen"
            colorScheme="blackAlpha"
            bg="rgba(0,0,0,0.6)"
            color="white"
            size="lg"
            onClick={toggleFullscreen}
            _hover={{ bg: "rgba(0,0,0,0.8)" }}
          />
        </Box>
      )}
    </Box>
  );
};

export default Banner;











